<template>
    <drawer-layout>
        <template v-slot:app-bar-title>
            <h2>Profile</h2>
        </template>

        <v-card flat>
            <v-container fluid>
                <!-- Profile Information -->
                <update-profile-information-form
                    :user="$page.props.user"
                />

                <!-- Update Password -->
                <update-password-form />

                <!-- Two Factor Authentication  -->
                <two-factor-authentication-form
                    :requires-confirmation="confirmsTwoFactorAuthentication"
                />

                <!-- Browser Sessions -->
                <logout-other-browser-sessions-form
                    :sessions="sessions"
                />

                <!-- Delete Account  -->
            </v-container>
        </v-card>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import UpdateProfileInformationForm from "@/Pages/Profile/Partials/UpdateProfileInformationForm";
import UpdatePasswordForm from "@/Pages/Profile/Partials/UpdatePasswordForm";
import TwoFactorAuthenticationForm from "@/Pages/Profile/Partials/TwoFactorAuthenticationForm";
import LogoutOtherBrowserSessionsForm from "@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm";

export default {
    components: {
        LogoutOtherBrowserSessionsForm,
        TwoFactorAuthenticationForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
        DrawerLayout
    },

    props: {
        confirmsTwoFactorAuthentication: Boolean,
        sessions: Array,
    },
}
</script>

<style scoped>

</style>
